import IconBtn from "components/lib-ui/IconBtn";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Link, Stack, Chip } from "@mui/material";
import PhoneCallDoneRow from "./_sections/LinqTableRows/PhoneCallDoneRow";
import NoteRow from "./_sections/LinqTableRows/NoteRow";
import { LinqRequestStatusChip } from "./_sections/LinqRequestStatusChip";
import { urlService } from "infra/envs";

const latestActionChipColumn = ({
    field,
    headerName,
    sequence,
    labels,
    width = 240,
}) => ({
    field,
    headerName,
    sortable: false,
    width,
    renderCell: ({ row }) => {
        const sent = row[field] || {};
        const latestKey = sequence.filter((key) => sent[key]).pop();

        if (!latestKey) return <>-</>;

        return (
            <Stack direction="row" alignItems="center">
                <Chip
                    label={labels[latestKey]}
                    size="small"
                    variant="outlined"
                />
            </Stack>
        );
    },
});

export const linqTableColumnHeaders = () => [
    {
        field: "candidateId",
        headerName: "#",
        width: 60,
        sortable: false,
    },
    {
        field: "candidateName",
        headerName: "Candidate Name",
        width: 160,
        sortable: false,
        cellClassName: "hoverable",
        renderCell: (params) => {
            return (
                <Stack>
                    <Link
                        href={`/candidate/view/${params.row?.candidateId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="hover"
                        sx={{
                            whiteSpace: "pre-line",
                            color: "black",
                        }}
                    >
                        {params.row?.candidateName}
                    </Link>
                </Stack>
            );
        },
    },
    {
        field: "jobLink",
        headerName: "Job",
        sortable: false,
        cellClassName: "hoverable",
        width: 240,
        renderCell: (params) => {
            return (
                <Stack>
                    <Link
                        href={`${urlService.B2C_VIEW_JOB_PATH_EN}/${params.row?.jobId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="hover"
                        sx={{
                            whiteSpace: "pre-line",
                            color: "black",
                        }}
                    >
                        {params.row?.jobHeadline}
                    </Link>
                </Stack>
            );
        },
    },
    {
        field: "companyName",
        headerName: "Company",
        sortable: false,
        width: 160,
    },
    latestActionChipColumn({
        field: "emailSent",
        headerName: "Email Actions",
        sequence: ["1st_email", "2_days_reminder", "4_days_reminder"],
        labels: {
            "1st_email": "First email",
            "2_days_reminder": "2‑day reminder",
            "4_days_reminder": "4‑day reminder",
        },
    }),
    latestActionChipColumn({
        field: "smsSent",
        headerName: "SMS Actions",
        sequence: ["1st_sms", "2_days_reminder", "5_days_reminder"],
        labels: {
            "1st_sms": "First sms",
            "2_days_reminder": "2‑day sms reminder",
            "5_days_reminder": "5‑day sms reminder",
        },
    }),
    {
        field: "phoneCallDone",
        headerName: "Phone Call Done",
        sortable: false,
        width: 300,
        renderCell: (params) => {
            return (
                <PhoneCallDoneRow
                    phoneCalls={params.row?.phoneCalls || []}
                    id={params.row?.linqRequestId}
                />
            );
        },
    },
    {
        field: "submittedBy",
        headerName: "Submitted By",
        sortable: false,
        width: 160,
    },
    {
        field: "status",
        headerName: "Status",
        sortable: false,
        width: 160,
        renderCell: (params) => {
            return <LinqRequestStatusChip status={params.row.status} />;
        },
    },
    {
        field: "dateUpdated",
        headerName: "Date Created/Updated",
        sortable: false,
        width: 180,
    },
    {
        field: "note",
        headerName: "Note",
        editable: false,
        sortable: false,
        width: 160,
        renderCell: (params) => {
            return (
                <NoteRow
                    defaultNote={params?.row?.note || ""}
                    id={params.row?.linqRequestId}
                />
            );
        },
    },
    {
        field: "expiresAt",
        headerName: "Expires At",
        editable: false,
        sortable: false,
        width: 160,
        renderCell: (params) => {
            const STATUS_PENDING = 1;
            const { status, expiresAt } = params.row;

            const isRequestAnswered = status !== STATUS_PENDING;
            const isExpired = expiresAt.timestamp * 1000 < Date.now();
            const expiresAtLabel = expiresAt.human;

            if (isExpired) return "Expired";
            if (isRequestAnswered) return "Resolved";

            return expiresAtLabel;
        },
    },
    {
        field: "timeToRespond",
        headerName: "Time to Respond",
        sortable: false,
        width: 160,
    },
    {
        field: "edit",
        headerName: "",
        description: "",
        sortable: false,
        width: 55,
        renderCell: () => (
            <div>
                <IconBtn
                    defaulted={true}
                    sx={{
                        top: 0,
                        right: 0,
                        border: "unset",
                    }}
                    icon={EditOutlinedIcon}
                    iconStyles={{ fontSize: "1.2rem" }}
                ></IconBtn>
            </div>
        ),
    },
];

export default linqTableColumnHeaders;
